module.exports = __webpack_public_path__ + "static/media/bolso (31).48cc4b16.jpg";